import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, InputLabel, ListItem, TextField, Typography } from '@mui/material'
import { ApiGetCategoryList } from '../../../apiService/Core/Apicall.tsx'
import { Link, useNavigate } from 'react-router-dom'
import edit from '../../../assets/images/editIcon.png'



function Categorylist() {

    const [CategoryList, setCategoryList] = useState<any[]>([])
    const [search, setsearch] = useState<string>('')
    const [filterItems, setfilterItems] = useState<any[]>([])

    const navigate = useNavigate()


    useEffect(() => {
        const getCategoryList = async () => {
            const response = await ApiGetCategoryList()
            setCategoryList(response.data)
        }
        getCategoryList()
    }, [])

    useEffect(() => {
        if (CategoryList) {
            const filteredCategories = CategoryList.filter(category =>
                category.categoryName.toLowerCase().includes(search.toLowerCase())
            );
            setfilterItems(filteredCategories)
        }
    }, [search, CategoryList])

    return (
        <Box className='container-fluid p-3 extra' bgcolor='white' minHeight='calc(100vh - 180px)'>
            <Box className='d-flex mb-3 align-items-center flex-wrap justify-content-between' gap={2}>
                <Typography className='fw-bold col-12 col-md-auto' textAlign={{ xs: "center", md: "start" }} variant='h4'>Category List</Typography>
                {/* <Button variant="contained" onClick={() => { navigate('/admin/others/add-or-upate-category') }} className="table-row-background my-1 ml-auto" sx={{ width: 'fit-content', textTransform: 'none' }}>Add Category</Button> */}
                <Link
                    to={`/admin/others/add-or-upate-category`}
                    className='link-btn'
                >
                    Add Category
                </Link>
            </Box>
            <FormControl className='my-3 mt-4 col-12'>
                <InputLabel>Search Category</InputLabel>
                <TextField
                    value={search}
                    onChange={(e) => { setsearch(e.target.value) }}
                />
            </FormControl>
            <Box className='d-flex align-items-center flex-wrap justify-content-between'>
                {filterItems && filterItems.map((item: any, index: number) => (
                    <Box width={{ xs: "100%", md: '33%' }} key={index} className='p-3 mt-2' sx={{ border: '1px solid #0000001A', borderRadius: '10px' }}>
                        <Box className=' d-flex justify-content-between align-items-center gap-1'>
                            <Box className='col-11 px-0 d-flex align-items-center mb-1 justify-content-between'>
                                <Typography className='fw-bold  fs-18'>{item?.categoryName}</Typography>
                                <Typography className='fw-bold fs-18'>{item?.categoryWeightage}</Typography>
                            </Box>
                            <Link
                             to={`/admin/others/add-or-upate-category/${item?.categoryId}`}
                            >
                                <Box sx={{ width: { xs: "100%", md: '75%' }}} component='img' src={edit} />
                            </Link>


                        </Box>
                        <Box className='d-flex align-items-center mt-2' gap={2}>
                            <Box component='img' src={item?.mmUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.transportUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.bloomsUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.aldiUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                        </Box>
                    </Box>
                ))}
            </Box>

        </Box>

    )
}

export default Categorylist
